import React from "react";
import { Link, useLocation } from "react-router-dom";

export function Footer() {
  const location = useLocation();
  // The OIDC authorize page renders its own compact attribution row inline
  // with the sign-in form, so the global footer would be redundant.
  if (location.pathname.match(/^\/oidc\/[^/]+\/authorize\/?$/)) {
    return null;
  }
  return (
    <footer className="mt-16 border-t-2 border-ink">
      <div className="mx-auto flex w-full max-w-3xl flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-6 font-mono text-xs uppercase tracking-wider text-muted sm:px-6">
        <div>&copy; {new Date().getFullYear()} Long Division, LLC.</div>
        <div className="flex gap-6">
          <Link to="/terms" className="no-underline">
            Terms
          </Link>
          <Link to="/privacy" className="no-underline">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
}
